import React from "react"
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Breadcrumbs,
  BreadcrumbItem,
  Button,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowCircleRight, faChevronLeft, faSquare } from "@fortawesome/free-solid-svg-icons"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css

export default function MainContainer({
  children,
  pageName="",
  info=[],
  breadcrumbs = [],
  prevPage = {},
}) {
  return (
    <Card className="rounded-none min-h-screen border-3 lg:ml-64">
      <ToastContainer />
      {/* <CardHeader className="flex flex-col gap-2 items-start"> */}
        <div className="flex items-center justify-between w-full  ml-5  ">
          {/* breadcrumbs */}
          {breadcrumbs?.length > 0 && (
            <Breadcrumbs variant={"flat"} color="warning" className="text-xs">
              {breadcrumbs?.map((item) => {
                return (
                  <BreadcrumbItem className="text-xs" key={item}>
                    {item}
                  </BreadcrumbItem>
                )
              })}
            </Breadcrumbs>
          )}
          {/* end of breadcrumbs */}
          
        </div>
        <div>
          {/* page heading */}
         
            <div className="text-sm flex justify-between border-l-2 uppercase mt-1 items-center text-rose-700 
            bg-gradient-to-r from-rose-50 to-slate-50 
            border-0 border-l-stone-700
            w-full p-1 font-semibold ">
              <div>
              <FontAwesomeIcon icon={faArrowCircleRight} className="mr-2 text-stone-500" ></FontAwesomeIcon>
              {pageName}
              </div>
              {prevPage && prevPage?.show && (
            <Button
              size="sm"
              color="primary"
              className="text-xs bg-amber-500 h-7"
              startContent={<FontAwesomeIcon icon={faChevronLeft} />}
              onClick={prevPage?.onClick}
            >
              Back
            </Button>
          )}

            </div>
          
          {/* <div className=" text-gray-400 font-semibold">
            {info.map((infoItem, index) => {
              return (
                <div key={index} className="flex flex-row gap-2 text-yellow-500">
                  {infoItem.map((item, index) => {
                    return (
                      <p
                        key={index}
                        size="sm"
                        className={`rounded-none text-xs`}
                      >
                        {item}
                      </p>
                    )
                  })}
                </div>
              )
            })}
          </div> */}
          {/* end of page heading */}
        </div>
      {/* </CardHeader> */}
      <CardBody>{children}</CardBody>
      <CardFooter></CardFooter>
    </Card>
  )
}
